import React from "react";

export default function Badge({ children, className = "", icon: Icon }) {
  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/80",
        className,
      ].join(" ")}
    >
      {Icon ? <Icon className="h-4 w-4 opacity-80" /> : null}
      <span>{children}</span>
    </span>
  );
}
